module.exports = __webpack_public_path__ + "img/7.1606ed02.svg";